import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
  async getCCMMedicalNoteByPatientId (patientId) {
    const response = await _axios.get(
      `/ccmmedicalnote/getbypatientid/${patientId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM Medical Note by patient ID');
  },
  async getCCMMedicalNoteByCCMRecordId (ccmRecordId) {
    try {
      const response = await _axios.get(
        `/ccmmedicalnote/getbyccmrecordid/${ccmRecordId}`,
      );
      if (response.data.resFlag) {
        return response.data;
      }
      throw new CCMError('Error getting CCM Medical Note by CCM record ID');
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return [];
      }
      throw new CCMError('Error getting CCM Medical Note by CCM record ID', error);
    }
  },
  async getCCMMedicalNote (id) {
    const response = await _axios.get(`/ccmmedicalnote/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM Medical Note');
  },
  async addCCMMedicalNote (body) {
    const response = await _axios.post('/ccmmedicalnote', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error adding CCM Medical Note');
  },
  async updateCCMMedicalNote (id, body) {
    const response = await _axios.put(`/ccmmedicalnote/${id}`, body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error updating CCM Medical Note');
  },
  async deleteCCMMedicalNote (id) {
    const response = await _axios.delete(`/ccmmedicalnote/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting CCM Medical Note');
  },
};
